import { Theme } from '@material-ui/core';
import { CSSProperties } from 'react';
import { grey } from 'globals/colors';

export const getContainerBoxStyle = ({
  isActive,
  activeColor,
  isFirst,
  isLast,
}: {
  isActive: boolean;
  activeColor: string;
  isFirst: boolean;
  isLast: boolean;
}): CSSProperties => ({
  backgroundColor: isActive ? activeColor : undefined,
  borderTopLeftRadius: isFirst ? 10 : 0,
  borderRight: isLast ? 'none' : `1px solid ${grey.V4}`,
});

export const getLabelStyle = ({
  isActive,
  theme: { palette },
}: {
  isActive: boolean;
  theme: Theme;
}): CSSProperties => ({
  color: isActive ? palette.common.white : undefined,
});

export const getValueStyle = ({
  isActive,
  theme: { palette },
}: {
  isActive: boolean;
  theme: Theme;
}): CSSProperties => ({
  color: isActive ? palette.common.white : undefined,
});

export const getLineStyle = ({
  isActive,
  activeColor,
  theme: { palette },
}: {
  isActive: boolean;
  activeColor: string;
  theme: Theme;
}): CSSProperties => ({
  backgroundColor: isActive ? palette.common.white : activeColor,
});
